/* Zumpo/Number card. Outlines are inset shadows, so a selection never
   moves the cards beside it. */
.card {
  display: inline-flex;
  flex: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--zumpo-space-4);
  width: 112px;
  height: 144px;
  margin: 0;
  padding: 0 var(--zumpo-space-8);
  border: 0;
  border-radius: var(--zumpo-radius-16);
  box-shadow:
    var(--zumpo-shadow-cell-edge),
    inset 0 0 0 1px var(--zumpo-line);
  background: var(--zumpo-paper);
  color: var(--zumpo-ink);
  text-align: center;
}

.value {
  font: var(--zumpo-text-hero);
  letter-spacing: var(--zumpo-text-hero-tracking);
  white-space: nowrap;
}

.formula {
  font: var(--zumpo-text-small);
  letter-spacing: var(--zumpo-text-small-tracking);
  white-space: nowrap;
}

.compact {
  width: 76px;
  padding: 0 var(--zumpo-space-4);
  height: 100px;
  border-radius: var(--zumpo-radius-12);
}

.compact .value {
  font: var(--zumpo-text-title);
  letter-spacing: var(--zumpo-text-title-tracking);
}

.long .value {
  font: var(--zumpo-text-title);
  letter-spacing: var(--zumpo-text-title-tracking);
}

.compact.long .value {
  font: var(--zumpo-text-heading);
  letter-spacing: var(--zumpo-text-heading-tracking);
}

.selected {
  box-shadow:
    var(--zumpo-shadow-cell-edge),
    inset 0 0 0 3px var(--zumpo-ink);
}

.made {
  background: var(--zumpo-peach);
}

.solved {
  box-shadow:
    var(--zumpo-shadow-cell-edge),
    inset 0 0 0 3px var(--zumpo-green);
  background: var(--zumpo-lime);
}

.not-24 {
  box-shadow:
    var(--zumpo-shadow-cell-edge),
    inset 0 0 0 3px var(--zumpo-danger);
  color: var(--zumpo-danger);
}

.button {
  cursor: pointer;
}

@media (hover: hover) {
  .button:hover:not(:disabled, .selected) {
    box-shadow:
      var(--zumpo-shadow-cell-edge),
      inset 0 0 0 2px var(--zumpo-ink);
  }
}

.button:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}

.button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}
